import { createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ApiClient from "helpers/ApiClient";
import { getToken } from "helpers/Tokens";

const initialState: any = {
  costCentersList: [],
  loading:false
};

export const getCostCenters:any = createAsyncThunk<any>(
  "getCostCenters/setCostCenters",
  async (_, thunkAPI) => {
    try {
      let userData= getToken();
      const response = await ApiClient.get(`cost-center?limit=20&userId=${userData?.id}`);
      return response?.data?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const costCentersSlice = createSlice({
  name: "getCostCenters",
  initialState,
  reducers: {
    setCostCenters(state, action) {
      state.costCentersList = action.payload;
    },
  },
  extraReducers: {
    [getCostCenters.pending]: (state:any) => {
      state.loading = true
    },
    [getCostCenters.fulfilled]: (state:any, action: any) => {
      state.loading = false
      state.costCentersList = action.payload;
    },
    [getCostCenters.rejected]: (state:any) => {
      state.loading = false
    },
  },
});

export const { setCostCenters } = costCentersSlice.actions;
export default costCentersSlice;
